// extracted by mini-css-extract-plugin
export default {"checkmark":"PaymentSuccessModal_checkmark__-q6fq","popIn":"PaymentSuccessModal_popIn__ywk-i"};